(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beauty-announcement-schedule')) {
    customElements.define('beauty-announcement-schedule', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        customElements.whenDefined('slideshow-component').then(() => {
          if (!this.isConnected) return;
          this.slideshow = this.closest('slideshow-component');
          this.updateSchedule();
          document.addEventListener('visibilitychange', () => this.updateSchedule(), { signal: this.controller.signal });
        });
      }
      updateSchedule() {
        clearTimeout(this.scheduleTimer);
        const now = Date.now();
        const start = Number(this.dataset.start) * 1000;
        const end = Number(this.dataset.end) * 1000;
        const enabled = this.dataset.enabled === 'true' && start > 0 && end > start;
        const active = enabled && now >= start && now < end;
        const slideshow = this.slideshow;
        const slide = slideshow.slider.querySelector('[data-campaign-announcement]');
        if (active !== Boolean(slide)) {
          slideshow.pause();
          clearTimeout(slideshow.setPositionTimeout);
          if (active) slideshow.slider.append(this.querySelector('template').content.cloneNode(true));
          else slide.remove();
          slideshow.slider.scrollTo({ left: 0, behavior: 'instant' });
          slideshow.resetPages();
          slideshow.sliderFirstItemNode = slideshow.slider.querySelector('.slideshow__slide');
          slideshow.currentPage = 1;
          slideshow.setSlideVisibility();
          if (slideshow.slider.dataset.autoplay === 'true' && !slideshow.reducedMotion.matches && !slideshow.announcementBarArrowButtonWasClicked) slideshow.play();
        }
        const slides = [...slideshow.slider.querySelectorAll('.slideshow__slide')];
        slides.forEach((item, index) => item.setAttribute('aria-label', `${index + 1} ${this.dataset.of} ${slides.length}`));
        const boundary = [start, end].find((time) => time > now);
        if (enabled && boundary) this.scheduleTimer = setTimeout(() => this.updateSchedule(), Math.min(boundary - now + 50, 2147483647));
      }
      disconnectedCallback() {
        clearTimeout(this.scheduleTimer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beauty-brand-carousel')) {
    customElements.define('beauty-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.allSlides = [...this.querySelectorAll('[data-beauty-slide]')];
        if (this.allSlides.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.manualPaused = false;
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.transitioning = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pauseButton = this.querySelector('[data-pause]');
        this.allSelectors = [...this.querySelectorAll('[data-select]')];
        this.classList.add('is-enhanced');
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
        this.allSelectors.forEach((button) => button.addEventListener('click', () => this.show(this.selectors.indexOf(button)), options));
        this.pauseButton.addEventListener('click', () => {
          this.manualPaused = !this.manualPaused;
          this.refresh();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.refresh(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.refresh(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.refresh(); }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.refresh();
        }, options);
        document.addEventListener('visibilitychange', () => { this.updateSchedule(); this.refresh(); }, options);
        this.motion.addEventListener('change', () => this.refresh(), options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.refresh();
        });
        this.observer.observe(this);
        this.updateSchedule();
        this.refresh();
      }
      updateSchedule() {
        clearTimeout(this.scheduleTimer);
        const now = Date.now();
        const start = Number(this.dataset.campaignStart) * 1000;
        const end = Number(this.dataset.campaignEnd) * 1000;
        const hasCampaign = this.allSlides.some((slide) => slide.hasAttribute('data-beauty-campaign'));
        const active = hasCampaign && (this.dataset.campaignPreview === 'true' || now >= start && now < end);
        if (!this.slides || this.campaignActive !== active) {
          this.campaignActive = active;
          this.slides = this.allSlides.filter((slide) => slide.hasAttribute('data-beauty-campaign') ? active : !active || Number(slide.dataset.beautyBrand) <= 2);
          this.index = 0;
          this.transitioning = false;
          clearTimeout(this.cleanupTimer);
          this.allSlides.forEach((slide) => {
            const current = slide === this.slides[0];
            slide.hidden = !this.slides.includes(slide);
            slide.inert = !current;
            slide.setAttribute('aria-hidden', String(!current));
            slide.classList.toggle('is-active', current);
            slide.classList.remove('is-leaving');
          });
          this.selectors = this.allSelectors.filter((button) => this.slides.some((slide) => slide.id === button.dataset.slideId));
          this.allSelectors.forEach((button) => {
            button.hidden = !this.selectors.includes(button);
            button.setAttribute('aria-current', String(button === this.selectors[0]));
          });
          this.querySelector('.beauty-carousel__controls').hidden = this.slides.length < 2;
          this.refresh();
        }
        const boundary = [start, end].filter((time) => time > now).sort((a, b) => a - b)[0];
        if (hasCampaign && boundary && this.dataset.campaignPreview !== 'true') {
          this.scheduleTimer = setTimeout(() => this.updateSchedule(), Math.min(boundary - now + 50, 2147483647));
        }
      }
      refresh() {
        clearInterval(this.timer);
        const autoplay = this.dataset.autoplay === 'true';
        this.pauseButton.hidden = !autoplay || this.motion.matches;
        const label = this.manualPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.pauseButton.setAttribute('aria-label', label);
        this.pauseButton.setAttribute('aria-pressed', String(this.manualPaused));
        this.pauseButton.querySelector('[data-pause-label]').textContent = label;
        this.pauseButton.querySelector('[data-pause-icon]').textContent = this.manualPaused ? '▶' : 'Ⅱ';
        if (this.slides.length < 2 || !autoplay || this.manualPaused || this.motion.matches || this.hovered || this.focused || !this.inView || document.hidden) return;
        this.timer = setInterval(() => this.show(this.index + 1), Math.max(5, Number(this.dataset.interval) || 7) * 1000);
      }
      show(target) {
        const next = (target + this.slides.length) % this.slides.length;
        if (next === this.index || this.transitioning) return;
        this.transitioning = true;
        const outgoing = this.slides[this.index];
        const incoming = this.slides[next];
        incoming.getBoundingClientRect();
        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-leaving');
        outgoing.inert = true;
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('is-active');
        incoming.inert = false;
        incoming.setAttribute('aria-hidden', 'false');
        this.index = next;
        this.selectors.forEach((button, index) => button.setAttribute('aria-current', String(index === next)));
        this.cleanupTimer = setTimeout(() => {
          outgoing.classList.remove('is-leaving');
          this.transitioning = false;
        }, this.motion.matches ? 0 : 850);
        this.refresh();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.cleanupTimer);
        clearTimeout(this.scheduleTimer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const backToTop = document.querySelector('.beauty-back-to-top');
  if (backToTop) {
    const updateBackToTop = () => { backToTop.hidden = window.scrollY < 400; };
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    window.addEventListener('pageshow', updateBackToTop);
    updateBackToTop();
    backToTop.addEventListener('click', () => {
      const destination = document.querySelector('.header__heading-link') || document.querySelector('#MainContent');
      destination?.focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-with-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const marker = 'native-gift-v1';
  const gifts = (items) => items.filter((item) => item.properties?._gwp === marker);
  const signature = (items) => JSON.stringify(items.map((item) => [item.key, item.quantity, item.original_line_price]));

  class GiftWithPurchase extends HTMLElement {
    static allowance(state) {
      const unlocked = state.tiers.filter((tier) => tier.quantity > 0 && state.spend >= tier.minimum);
      const highest = unlocked.reduce((best, tier) => !best || tier.minimum > best.minimum ? tier : best, null);
      const variants = new Set(unlocked.flatMap((tier) => tier.variants.filter((variant) => variant.available).map((variant) => variant.id)));
      return { highest, variants };
    }

    static voucherIds(state) {
      return new Set(state.tiers.flatMap((tier) => tier.variants.filter((variant) => variant.voucher).map((variant) => variant.id)));
    }

    static plan(state) {
      if (!state.valid) return [];
      const { highest, variants } = this.allowance(state);
      let remaining = highest?.quantity || 0;
      const changes = [];
      const vouchers = this.voucherIds(state);
      let voucherRemaining = 1;
      for (const item of gifts(state.items)) {
        const quantity = variants.has(item.variant_id) && !item.selling_plan_allocation
          ? Math.min(item.quantity, remaining, vouchers.has(item.variant_id) ? voucherRemaining : remaining) : 0;
        if (vouchers.has(item.variant_id)) voucherRemaining -= quantity;
        remaining -= quantity;
        if (item.quantity !== quantity) changes.push({ id: item.key, quantity });
      }
      return changes;
    }

    static selectionAllowed(state, tierId, ids) {
      const { highest, variants } = this.allowance(state);
      return Boolean(state.valid && highest && highest.id === tierId && ids.length === highest.quantity &&
        ids.every((id) => variants.has(id)) && ids.filter((id) => this.voucherIds(state).has(id)).length <= 1);
    }

    connectedCallback() {
      this.state = JSON.parse(this.dataset.state);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-gwp-open]')) this.openDrawer();
        if (event.target.closest('[data-gwp-close]')) this.closeDrawer();
        if (event.target.closest('[data-gwp-voucher-close]')) this.querySelector('[data-gwp-voucher-dialog]')?.close();
        if (event.target.closest('[data-gwp-checkout-close]')) this.querySelector('[data-gwp-checkout-dialog]')?.close();
        if (event.target.closest('[data-gwp-checkout-continue]')) this.continueCheckout();
        const step = event.target.closest('[data-gwp-step]');
        if (step) {
          event.preventDefault();
          const input = step.parentElement.querySelector('input');
          if (input.disabled) return;
          const form = input.closest('form');
          const total = GiftWithPurchase.selectionIds(form).length;
          const limit = GiftWithPurchase.allowance(this.state).highest?.quantity || 0;
          const delta = Number(step.dataset.gwpStep);
          if (delta > 0 && total >= limit) return;
          input.value = String(Math.max(0, Math.min(limit, Number(input.value) + delta)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-gwp-search]')) this.filterGifts();
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-gwp-brand]')) this.filterGifts();
        const form = event.target.closest('[data-gwp-tier]');
        if (form) {
          const limit = GiftWithPurchase.allowance(this.state).highest?.quantity || 0;
          if (event.target.type === 'checkbox' && GiftWithPurchase.selectionIds(form).length > limit) event.target.checked = false;
          if (event.target.checked && GiftWithPurchase.voucherIds(this.state).has(Number(event.target.dataset.gwpVariant))) {
            const vouchers = GiftWithPurchase.voucherIds(this.state);
            form.querySelectorAll('[data-gwp-variant]').forEach((input) => {
              if (input !== event.target && vouchers.has(Number(input.dataset.gwpVariant))) input.checked = false;
            });
            if (window.matchMedia?.('(hover: none), (pointer: coarse), (max-width: 749px)')?.matches) {
              this.querySelector('[data-gwp-voucher-dialog]')?.showModal();
            }
          }
          this.updateSelection(form);
          const ids = GiftWithPurchase.selectionIds(form);
          if (form.checkValidity() && GiftWithPurchase.selectionAllowed(this.state, form.dataset.gwpTier, ids)) {
            window.gwpCartCoordinator.apply(form.dataset.gwpTier, ids, signature(this.state.items));
          }
        }
      });
      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-gwp-tier]');
        if (!form) return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        const ids = GiftWithPurchase.selectionIds(form);
        window.gwpCartCoordinator.apply(form.dataset.gwpTier, ids, signature(this.state.items));
      });
      if (!window.gwpCartCoordinator) window.gwpCartCoordinator = new GiftCartCoordinator();
      this.onCheckout = (event) => this.confirmCheckout(event);
      document.addEventListener('submit', this.onCheckout);
      window.gwpCartCoordinator.requestRefresh();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onCheckout);
    }

    confirmCheckout(event) {
      if (this.checkoutConfirmed || event.defaultPrevented || event.target.id !== 'cart' || event.submitter?.name !== 'checkout') return;
      const dialog = this.querySelector('[data-gwp-checkout-dialog]');
      if (!this.state.valid || !this.state.items.length || !dialog) return;
      event.preventDefault();
      this.checkoutSubmitter = event.submitter;
      this.querySelector('.gwp__dialog')?.close();
      if (!dialog.open) dialog.showModal();
      this.querySelector('[data-gwp-checkout-heading]')?.focus();
    }

    continueCheckout() {
      const submitter = this.checkoutSubmitter;
      if (!submitter?.isConnected || !submitter.form) {
        this.querySelector('[data-gwp-checkout-dialog]')?.close();
        return;
      }
      this.querySelector('[data-gwp-checkout-dialog]')?.close();
      this.checkoutConfirmed = true;
      try { submitter.form.requestSubmit(submitter); }
      finally { this.checkoutConfirmed = false; }
    }

    openDrawer() {
      const dialog = this.querySelector('dialog');
      if (!dialog || dialog.open) return;
      dialog.showModal();
      this.querySelector('[data-gwp-drawer-heading]').focus();
    }

    closeDrawer() {
      this.querySelector('dialog')?.close();
      (this.querySelector('[data-gwp-open]') || this.querySelector('[data-gwp-heading]'))?.focus();
    }

    filterGifts() {
      const query = (this.querySelector('[data-gwp-search]')?.value || '').trim().toLocaleLowerCase();
      const brand = this.querySelector('[data-gwp-brand]')?.value || '';
      let visible = 0;
      this.querySelectorAll('[data-gwp-search-text]').forEach((card) => {
        card.hidden = !card.dataset.gwpSearchText.toLocaleLowerCase().includes(query) || Boolean(brand && card.dataset.gwpVendor !== brand);
        if (!card.hidden) visible++;
      });
      const empty = this.querySelector('[data-gwp-no-results]');
      if (empty) empty.hidden = visible > 0;
      const future = this.querySelector('[data-gwp-future]');
      if (future && (query || brand)) {
        future.open = true;
        future.querySelectorAll('details').forEach((preview) => { preview.open = true; });
      }
    }

    drawerState() {
      return {
        open: Boolean(this.querySelector('dialog')?.open),
        voucherNotice: Boolean(this.querySelector('[data-gwp-voucher-dialog]')?.open),
        search: this.querySelector('[data-gwp-search]')?.value || '',
        brand: this.querySelector('[data-gwp-brand]')?.value || '',
        scroll: this.querySelector('.gwp__drawer-body')?.scrollTop || 0,
        windows: [...this.querySelectorAll('[data-gwp-window]')].map((panel) => ({
          id: panel.dataset.gwpWindow, scroll: panel.querySelector('.gwp__products')?.scrollTop || 0,
        })),
        future: Boolean(this.querySelector('[data-gwp-future]')?.open),
        signature: signature(this.state.items),
        tier: this.querySelector('[data-gwp-tier]')?.dataset.gwpTier,
        inputs: [...this.querySelectorAll('[data-gwp-variant]')].map((input) => ({ id: input.dataset.gwpVariant, value: input.value, checked: input.checked })),
      };
    }

    restoreDrawer(saved) {
      if (!saved?.open || this.hidden) return;
      const form = this.querySelector('[data-gwp-tier]');
      if (form && saved.tier === form.dataset.gwpTier && saved.signature === signature(this.state.items)) {
        form.querySelectorAll('[data-gwp-variant]').forEach((input) => {
          const previous = saved.inputs.find((entry) => entry.id === input.dataset.gwpVariant);
          if (previous) { input.value = previous.value; input.checked = previous.checked; }
        });
        this.updateSelection(form);
      }
      this.openDrawer();
      if (saved.voucherNotice) this.querySelector('[data-gwp-voucher-dialog]')?.showModal();
      const search = this.querySelector('[data-gwp-search]');
      const brand = this.querySelector('[data-gwp-brand]');
      if (search) search.value = saved.search;
      if (brand) brand.value = saved.brand;
      const future = this.querySelector('[data-gwp-future]');
      if (future) future.open = saved.future;
      this.filterGifts();
      this.querySelector('.gwp__drawer-body').scrollTop = saved.scroll;
      this.querySelectorAll('[data-gwp-window]').forEach((panel) => {
        const previous = saved.windows?.find((entry) => entry.id === panel.dataset.gwpWindow);
        if (previous) panel.querySelector('.gwp__products').scrollTop = previous.scroll;
      });
    }

    static selectionIds(form) {
      return [...form.querySelectorAll('[data-gwp-variant]')].flatMap((input) => {
        if (input.disabled) return [];
        const quantity = input.type === 'radio' || input.type === 'checkbox' ? Number(input.checked) : Number(input.value);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > 5) return [];
        return Array(quantity).fill(Number(input.dataset.gwpVariant));
      });
    }

    updateSelection(form) {
      const ids = GiftWithPurchase.selectionIds(form);
      const vouchers = GiftWithPurchase.voucherIds(this.state);
      const hasVoucher = ids.some((id) => vouchers.has(id));
      form.querySelectorAll('[data-gwp-variant]').forEach((input) => {
        if (vouchers.has(Number(input.dataset.gwpVariant))) {
          input.disabled = hasVoucher && !input.checked;
          input.closest('.gwp__card').dataset.exclusiveBlocked = String(input.disabled);
        }
      });
      const status = form.querySelector('[data-gwp-selection-status]');
      status.textContent = status.dataset.template.replace('[count]', ids.length);
      const footer = this.querySelector('[data-gwp-drawer-status]');
      if (footer) footer.textContent = status.textContent;
      const done = this.querySelector('[data-gwp-done]');
      if (done) {
        const selected = gifts(this.state.items).flatMap((item) => Array(item.quantity).fill(item.variant_id)).sort();
        done.disabled = JSON.stringify([...ids].sort()) !== JSON.stringify(selected);
      }
      form.querySelectorAll('[data-gwp-variant]').forEach((input) => {
        input.closest('.gwp__card').dataset.selected = String(input.type === 'radio' || input.type === 'checkbox' ? input.checked : Number(input.value) > 0);
      });
    }

    setPending(selection) {
      this.querySelectorAll('[data-gwp-tier]').forEach((form) => {
        form.querySelectorAll('.gwp__card').forEach((card) => {
          const input = card.querySelector('[data-gwp-variant]');
          card.dataset.pending = String(Boolean(selection && form.dataset.gwpTier === selection.tierId && selection.ids.includes(Number(input?.dataset.gwpVariant))));
        });
      });
    }

    sortProducts() {
      const collator = new Intl.Collator(document.documentElement?.lang || 'de', { sensitivity: 'base', numeric: true });
      this.querySelectorAll('.gwp__products, .gwp__preview-products').forEach((container) => {
        if (!container.children) return;
        const title = (card) => (card.querySelector('.gwp__title')?.textContent || card.textContent).trim();
        [...container.children].sort((a, b) => collator.compare(title(a), title(b)))
          .forEach((card) => container.appendChild(card));
      });
    }

    hydrate() {
      this.state = JSON.parse(this.dataset.state);
      this.hidden = this.state.items.length === 0;
      const brands = this.querySelector('[data-gwp-brand]');
      if (brands) {
        const vendors = [...new Set([...this.querySelectorAll('[data-gwp-vendor]')].map((card) => card.dataset.gwpVendor).filter(Boolean))].sort();
        vendors.forEach((vendor) => brands.add(new Option(vendor, vendor)));
      }
      const selected = gifts(this.state.items);
      this.sortProducts();
      const forms = [...this.querySelectorAll('[data-gwp-tier]')];
      forms.forEach((form) => {
        form.hidden = false;
        form.querySelectorAll('[data-gwp-variant]').forEach((input) => {
          const quantity = selected.filter((item) => String(item.variant_id) === input.dataset.gwpVariant)
            .reduce((total, item) => total + item.quantity, 0);
          input.closest('.gwp__card').dataset.inCart = String(quantity > 0);
          if (input.type === 'radio' || input.type === 'checkbox') input.checked = quantity > 0;
          else input.value = String(Math.min(quantity, 5));
        });
        this.updateSelection(form);
      });
    }
  }

  class GiftCartCoordinator {
    constructor() {
      this.tail = Promise.resolve();
      this.busy = false;
      this.refreshPending = false;
      this.lastGiftMinimum = new Map();
      this.lastGiftCount = new Map();
      this.lastGiftPrice = new Map();
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items' && this.busy) return;
        if (event.source !== 'gift-selector') this.requestRefresh();
      });
      window.addEventListener('pageshow', (event) => { if (event.persisted) this.requestRefresh(); });
      window.addEventListener('focus', () => this.requestRefresh());
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.requestRefresh(); });
    }

    get root() { return document.querySelector('gift-with-purchase'); }
    get state() { return this.root?.state; }

    showUnlockedGift() {
      const state = this.state;
      if (!state?.valid) return;
      const highest = GiftWithPurchase.allowance(state).highest;
      const minimum = state.items.length ? highest?.minimum || 0 : 0;
      const count = gifts(state.items).reduce((total, item) => total + item.quantity, 0);
      const key = `beauty-gwp-threshold:${state.currency}`;
      const price = JSON.stringify([state.spend, state.totalPrice]);
      let previous = this.lastGiftMinimum.get(key);
      let previousCount = this.lastGiftCount.get(key);
      let previousPrice = this.lastGiftPrice.get(key);
      if (previous === undefined) {
        try { previous = Number(window.sessionStorage.getItem(key)) || 0; } catch (_) { previous = 0; }
      }
      if (previousCount === undefined) {
        try { previousCount = Number(window.sessionStorage.getItem(`${key}:count`)) || 0; } catch (_) { previousCount = 0; }
      }
      if (previousPrice === undefined) {
        try { previousPrice = window.sessionStorage.getItem(`${key}:price`); } catch (_) { previousPrice = null; }
      }
      this.lastGiftMinimum.set(key, minimum);
      this.lastGiftCount.set(key, count);
      this.lastGiftPrice.set(key, price);
      try {
        window.sessionStorage.setItem(key, String(minimum));
        window.sessionStorage.setItem(`${key}:count`, String(count));
        window.sessionStorage.setItem(`${key}:price`, price);
      } catch (_) {}
      const removedGift = minimum > 0 && count < previousCount && count < highest.quantity;
      const priceChanged = previousPrice != null && previousPrice !== price;
      if (highest && count < highest.quantity && (minimum > previous || removedGift || priceChanged) && this.root.querySelector('[data-gwp-tier]')) this.root.openDrawer();
    }

    message(kind) {
      if (this.root) {
        const status = this.root.querySelector('[data-gwp-status]');
        status.textContent = this.root.dataset[kind] || '';
        status.className = kind === 'updated' || kind === 'pending' ? 'visually-hidden' : '';
        const footer = this.root.querySelector('[data-gwp-drawer-status]');
        if (footer) {
          if (kind === 'updated' || !kind) {
            const selection = this.root.querySelector('[data-gwp-selection-status]');
            footer.textContent = selection?.textContent || '';
          } else footer.textContent = this.root.dataset[kind] || '';
        }
        const done = this.root.querySelector('[data-gwp-done]');
        if (done && kind === 'error') done.disabled = true;
      }
    }

    async json(url, body, accept = 'application/json') {
      const response = await fetch(url, body ? {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      } : { cache: 'no-store', headers: { Accept: accept } });
      const data = await response.json();
      if (!response.ok || data.errors || data.status >= 400) {
        const detail = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : '';
        const error = new Error(detail || 'Cart request failed');
        error.cartDetail = detail;
        error.status = response.status;
        throw error;
      }
      return data;
    }

    cart() { return this.json(`${window.Shopify.routes.root}cart.js`); }
    change(body) { return this.json(`${window.Shopify.routes.root}cart/change.js`, body); }

    lock() {
      this.locked = [...document.querySelectorAll('cart-items, cart-drawer, #main-cart-footer, gift-with-purchase')]
        .map((node) => ({ node, inert: node.inert }));
      this.locked.forEach(({ node }) => { node.inert = true; });
      this.root?.setAttribute('aria-busy', 'true');
      const dialog = this.root?.querySelector('dialog');
      if (dialog) dialog.inert = true;
    }

    unlock() {
      this.locked?.forEach(({ node, inert }) => { node.inert = inert; });
      this.root?.removeAttribute('aria-busy');
      const dialog = this.root?.querySelector('dialog');
      if (dialog) dialog.inert = false;
    }

    run(work, focus = false) {
      const operation = async () => {
        if (!this.root) return;
        this.busy = true;
        const focusedId = document.activeElement?.id;
        this.lock();
        this.message('pending');
        try {
          await work();
        } catch (error) {
          console.error('Gift selector cart update failed:', error);
          try { await this.refresh(); } catch (_) {}
          this.message('error');
          if (error.cartDetail) {
            ['[data-gwp-status]', '[data-gwp-drawer-status]'].forEach((selector) => {
              const status = this.root?.querySelector(selector);
              if (status) status.textContent = `${this.root.dataset.error} ${error.cartDetail}`;
            });
          }
        } finally {
          this.unlock();
          this.busy = false;
          if (focus) this.root?.querySelector(this.root.querySelector('dialog')?.open ? '[data-gwp-drawer-heading]' : '[data-gwp-heading]')?.focus();
          else if (focusedId) document.getElementById(focusedId)?.focus();
          this.showUnlockedGift();
        }
      };
      const lockedOperation = () => navigator.locks
        ? navigator.locks.request('native-gift-cart', operation)
        : operation();
      const result = this.tail.then(lockedOperation, lockedOperation);
      this.tail = result.catch(() => {});
      return result;
    }

    requestRefresh() {
      if (this.refreshPending) return this.tail;
      this.refreshPending = true;
      return this.run(async () => {
        this.refreshPending = false;
        const changed = await this.reconcile();
        this.message(changed ? 'reconciled' : '');
      });
    }

    async refresh() {
      const root = this.root;
      if (!root) return;
      const cartItems = document.querySelector('cart-items');
      if (cartItems) await customElements.whenDefined('cart-items');
      const sections = cartItems?.getSectionsToRender() || [];
      const sectionId = root.dataset.section;
      const ids = [...new Set([...sections.map((section) => section.section), sectionId])];
      const url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', ids.join(','));
      const html = await this.json(url.toString(), undefined, 'text/html');
      if (ids.some((id) => typeof html[id] !== 'string')) throw new Error('Section rendering failed');
      const parsed = new DOMParser().parseFromString(html[sectionId], 'text/html');
      const source = parsed.querySelector('gift-with-purchase');
      if (!source) throw new Error('Gift settings changed');
      const replacements = sections.map((section) => {
        const target = document.getElementById(section.id);
        const fragment = new DOMParser().parseFromString(html[section.section], 'text/html').querySelector(section.selector);
        if (!target || !fragment) throw new Error('Cart section missing');
        return { target: target.querySelector(section.selector) || target, html: fragment.innerHTML };
      });
      replacements.forEach(({ target, html }) => { target.innerHTML = html; });
      const drawer = root.drawerState?.();
      root.querySelector('dialog')?.close();
      root.innerHTML = source.innerHTML;
      Object.assign(root.dataset, source.dataset);
      root.hydrate();
      root.restoreDrawer?.(drawer);
      const dialog = root.querySelector('dialog');
      if (dialog) dialog.inert = this.busy;
      if (this.pendingSelection) {
        root.setPending?.(this.pendingSelection);
        this.message('pending');
      }
      const empty = !root.state.items.length;
      cartItems?.classList.toggle('is-empty', empty);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', empty);
    }

    async reconcile() {
      let changed = false;
      for (let round = 0; round < 20; round++) {
        await this.refresh();
        const adjustment = GiftWithPurchase.plan(this.state)[0];
        if (!adjustment) return changed;
        const current = await this.cart();
        if (signature(current.items) !== signature(this.state.items)) continue;
        await this.change(adjustment);
        changed = true;
      }
      throw new Error('Cart did not settle');
    }

    async clearSelections() {
      for (let round = 0; round < 20; round++) {
        const current = await this.cart();
        const item = gifts(current.items)[0];
        if (!item) return;
        await this.change({ id: item.key, quantity: 0 });
      }
      throw new Error('Cart did not settle');
    }

    apply(tierId, ids, expectedSignature) {
      if (this.busy || this.pendingSelection) return;
      this.pendingSelection = { tierId, ids: [...ids] };
      this.root?.setPending?.(this.pendingSelection);
      this.message('pending');
      return this.run(async () => {
        await this.refresh();
        if (signature(this.state.items) !== expectedSignature || !GiftWithPurchase.selectionAllowed(this.state, tierId, ids)) {
          this.message('stale');
          return;
        }
        const current = await this.cart();
        if (signature(current.items) !== signature(this.state.items)) {
          await this.refresh();
          this.message('stale');
          return;
        }
        if (gifts(current.items).length) {
          await this.clearSelections();
          await this.refresh();
        }
        if (!GiftWithPurchase.selectionAllowed(this.state, tierId, ids)) {
          this.message('stale');
          return;
        }
        const quantities = new Map();
        ids.forEach((id) => quantities.set(id, (quantities.get(id) || 0) + 1));
        await this.json(`${window.Shopify.routes.root}cart/add.js`, {
          items: [...quantities].map(([id, quantity]) => ({ id, quantity, properties: { _gwp: marker, _gwp_tier: tierId } })),
        });
        const changed = await this.reconcile();
        this.message(changed ? 'reconciled' : 'updated');
        const cartData = await this.cart();
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-selector', cartData });
        const confirmed = gifts(cartData.items).flatMap((item) => Array(item.quantity).fill(item.variant_id)).sort();
        if (JSON.stringify(confirmed) === JSON.stringify([...ids].sort())) this.root?.closeDrawer?.();
      }, true).finally(() => {
        this.pendingSelection = null;
        this.root?.setPending?.(null);
      });
    }

    remove() {
      if (this.busy) return;
      return this.run(async () => {
        await this.clearSelections();
        await this.refresh();
        this.message('updated');
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-selector', cartData: await this.cart() });
      }, true);
    }

    changeQuantity(element, line, quantity, event, name, variantId) {
      const input = element.querySelector(`#Quantity-${line}`) || element.querySelector(`#Drawer-quantity-${line}`);
      const key = input?.dataset.quantityLineKey;
      return this.run(async () => {
        const current = await this.cart();
        const index = current.items.findIndex((item) => item.key === key);
        if (index < 0) {
          await this.refresh();
          this.message('stale');
          return;
        }
        const result = await element.performUpdateQuantity(line, quantity, event, name, variantId, current.items[index].key);
        if (!result || result.errors) throw new Error('Native cart update failed');
        const changed = await this.reconcile();
        this.message(changed ? 'reconciled' : '');
      });
    }
  }

  if (!customElements.get('gift-with-purchase')) customElements.define('gift-with-purchase', GiftWithPurchase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
